import { Component, OnInit } from '@angular/core';
import { environment } from "src/environments/environment";
import { Router} from "@angular/router";
import { AppService } from '../app.service';

declare var gtag;
declare var fbq;

@Component({
  selector: 'app-listforsale',
  templateUrl: './listforsale.component.html',
  styleUrls: ['./listforsale.component.css']
})
export class ListforsaleComponent implements OnInit {

  constructor(private router: Router,private service:AppService) { }

  ngOnInit() {
    if(environment.production){
    this.service.sendEvents("Completelistsale", "listsale", "ListSale");
    fbq('track', "CompleteListSale" , {
      content_type: "listsale",
      content_title: this.router.url,
    });
  }
  }

}
